/* ==========================================================================
   LUNEXUS — Cart Drawer V4 (Horizon 4.1.4) · Clean Design · Toast statt Auto-Open
   ========================================================================== */
(function(){
  'use strict';

  /* FIX5: keine Lieferdaten, keine Uhrzeit-Countdowns (CONTENT-REGELN: keine erfundenen Lieferzeiten) */
  var INJECTING=false;

  /* Texte: aus <script id="lx-i18n-cart"> (Locale), Fallback Deutsch */
  var T={info_std:'Versand über das Amazon-Logistiknetz',info_de:'Versand über das Amazon-Logistiknetz · in Deutschland kostenlos',info_fig:'Holzfiguren: versicherter Versand aus Südtirol · Lieferzeit ca. 3–4 Wochen',instock:'Auf Lager',fig_line:'Lieferzeit ca. 3–4 Wochen',free_de:'Versandkostenfrei in Deutschland',ret30:'30 Tage Rückgabe',ret14:'14 Tage Widerrufsrecht',ret_mix:'30 Tage Rückgabe · Figuren 14 Tage',ssl:'SSL',ssl_long:'SSL-verschlüsselt',service:'Persönlicher Service',checkout:'Sicher zur Kasse',save:'Du sparst',discount:'Rabatt',total:'Gesamt',fit:'Passt dazu',add:'+ Hinzufügen',added:'Produkt erfolgreich hinzugefügt',to_cart:'Zum Warenkorb',empty_h:'Dein Warenkorb ist leer',empty_p:'Entdecke unsere handverlesenen Devotionalien – persönlich ausgewählt und mit Liebe verpackt.',empty_cta:'Sortiment entdecken',f1_t:'Gratis Versand DE',f1_s:'Kostenloser Versand in Deutschland (außer Holzfiguren)',f2_t:'Viele Artikel gesegnet',f2_s:'Mit Zertifikat, erkennbar am Hinweis „gesegnet“',f3_t:'30 Tage Rückgabe',f3_s:'Für Artikel aus unserem Lager (Figuren: 14 Tage)',more:'Weiter einkaufen',each:'je',also_like:'Das könnte dir auch gefallen',view_all:'Alle ansehen'};
  try{var tj=document.getElementById('lx-i18n-cart');if(tj){var o=JSON.parse(tj.textContent);for(var k in o){if(o[k])T[k]=o[k];}}}catch(e){}
  function esc(x){return String(x==null?'':x).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function country(){return (document.body&&document.body.dataset.lxCountry)||'DE';}
  /* Figur NUR per Tag typ:figur (Liquid setzt data-lx-figur an jeder Warenkorbzeile) */
  function cartFigurState(root){
    var rows=(root||document).querySelectorAll('tr[data-lx-figur]');var f=0,n=0;
    rows.forEach(function(r){if(r.dataset.lxFigur==='true')f++;else n++;});
    return{fig:f>0,std:n>0};
  }

  /* ── SVG Icons ─────────────────────────────────────── */
  var IC='<svg viewBox="0 0 24 24" fill="none" stroke-width="2" style="width:12px;height:12px"';
  function svgCheck(c){return IC+' stroke="'+c+'"><polyline points="20 6 9 17 4 12"/></svg>';}
  function svgClock(c){return IC+' stroke="'+c+'" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';}
  var S_LOCK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:10px;height:10px"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>';
  var S_OK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:10px;height:10px"><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="10"/></svg>';
  var S_DONE='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:10px;height:10px"><path d="M20 6L9 17l-5-5"/></svg>';

  /* ── HTML Builder ──────────────────────────────────── */
  function buildInfoBar(st){
    var parts=[];
    if(st.std)parts.push(country()==='DE'?T.info_de:T.info_std);
    if(st.fig)parts.push(T.info_fig);
    return '<div class="lx-ci"><div class="lx-ci__row lx-ci__row--ship">'+svgCheck('#2A6E4C')+'<span class="lx-ci__txt">'+esc(parts.join(' · '))+'</span></div></div>';
  }

  /* Figuren-Sortiment (Holzschnitzfiguren): NUR Tag "typ:figur" (nie Produkttyp).
     Wird NIE mit guenstigen Artikeln kombiniert (Vorschlaege/Upsell). */
  function isFigurProduct(p){
    if(!p)return false;
    var tags=p.tags||[];
    if(typeof tags==='string')tags=tags.split(',');
    for(var i=0;i<tags.length;i++){if(String(tags[i]).trim().toLowerCase()==='typ:figur')return true;}
    return false;
  }
  window.lxIsFigurProduct=isFigurProduct;

  function fmtEur(cents){return (cents/100).toFixed(2).replace('.',',');}

  function buildSave(cart){
    if(!(cart.total_discount>0))return '';
    return '<div class="lx-ft__save">'+esc(T.save)+' '+fmtEur(cart.total_discount)+' &#x20AC; ('+esc(T.discount)+')</div>';
  }

  function retText(st){return st.fig&&st.std?T.ret_mix:(st.fig?T.ret14:T.ret30);}
  function buildTrust(st){
    return '<div class="lx-ft__trust"><span class="lx-ft__ti">'+S_LOCK+' '+esc(T.ssl)+'</span><span class="lx-ft__ti" data-lx-ret>'+S_OK+' '+esc(retText(st))+'</span><span class="lx-ft__ti">'+S_DONE+' '+esc(T.service)+'</span></div>'+
      ''; /* Warm: Zahlarten-Icons kommen aus cart-summary.liquid (shop.enabled_payment_types) */
  }

  function buildUpsell(p){
    var img=p.featured_image||'';
    var title=p.title.length>40?p.title.substring(0,37)+'…':p.title;
    var price=(parseInt(p.variants[0].price)/100).toFixed(2).replace('.',',');
    var vid=p.variants[0].id;
    var sep=img.indexOf('?')>-1?'&':'?';
    return '<div class="lx-ups"><div class="lx-ups__l">'+esc(T.fit)+'</div><div class="lx-ups__c">'+
      (img?'<img class="lx-ups__img" src="'+esc(img+sep+'width=88')+'" alt="" loading="lazy" width="44" height="44">':'<div class="lx-ups__img"></div>')+
      '<div class="lx-ups__inf"><div class="lx-ups__n">'+esc(title)+'</div><div class="lx-ups__p">'+price+' &#x20AC;</div></div>'+
      '<button class="lx-ups__btn" type="button" onclick="lxAddToCart('+(+vid)+',this)">'+esc(T.add)+'</button></div></div>';
  }

  function emptyFeats(cls,sz){
    return '<div class="'+cls+'__feats">'+
        '<div class="'+cls+'__f"><div class="'+cls+'__fi '+cls+'__fi--g"><svg viewBox="0 0 24 24" fill="none" stroke="#1a5c30" stroke-width="2" style="width:'+sz+'px;height:'+sz+'px"><polyline points="20 6 9 17 4 12"/></svg></div><div><div class="'+cls+'__ft">'+esc(T.f1_t)+'</div><div class="'+cls+'__fs">'+esc(T.f1_s)+'</div></div></div>'+
        '<div class="'+cls+'__f"><div class="'+cls+'__fi '+cls+'__fi--l"><svg viewBox="0 0 24 24" fill="none" stroke="#6b2a7a" stroke-width="2" style="width:'+sz+'px;height:'+sz+'px"><line x1="12" y1="3" x2="12" y2="21"/><line x1="5" y1="9" x2="19" y2="9"/></svg></div><div><div class="'+cls+'__ft">'+esc(T.f2_t)+'</div><div class="'+cls+'__fs">'+esc(T.f2_s)+'</div></div></div>'+
        '<div class="'+cls+'__f"><div class="'+cls+'__fi '+cls+'__fi--w"><svg viewBox="0 0 24 24" fill="none" stroke="#7a4a00" stroke-width="1.8" style="width:'+sz+'px;height:'+sz+'px"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg></div><div><div class="'+cls+'__ft">'+esc(T.f3_t)+'</div><div class="'+cls+'__fs">'+esc(T.f3_s)+'</div></div></div>'+
      '</div>';
  }
  function allUrl(){return (window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'collections/all';}
  function buildEmpty(){
    return '<div class="lx-empty">'+
      '<svg class="lx-empty__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>'+
      '<div class="lx-empty__h">'+esc(T.empty_h)+'</div>'+
      '<div class="lx-empty__p">'+esc(T.empty_p)+'</div>'+
      '<a class="lx-empty__cta" href="'+allUrl()+'">'+esc(T.empty_cta)+'</a>'+
      emptyFeats('lx-empty',12)+'</div>';
  }

  /* ── Drawer-Inhalt neu laden (Section Rendering API, Section "cart-drawer-section") ── */
  function refreshDrawer(done){
    var sid=document.querySelector('#cart-drawer cart-items-component')||document.querySelector('cart-items-component');
    var secId=sid&&sid.dataset.sectionId;
    if(!sid||!secId){if(done)done(false);return;}
    return fetch('/?sections='+secId).then(function(r){return r.json();}).then(function(secs){
      var html=secs[secId];if(!html){if(done)done(false);return;}
      INJECTING=true;if(observer)observer.disconnect();
      var tmp=document.createElement('div');tmp.innerHTML=html;
      var nc=tmp.querySelector('cart-items-component');
      if(nc)sid.innerHTML=nc.innerHTML;
      var inner=document.querySelector('#cart-drawer .cart-drawer__inner');
      if(inner)inner.classList.remove('cart-drawer--empty');
      refreshBubbles();
      setTimeout(function(){INJECTING=false;enhance();startObs();},300);
      if(done)done(true);
    }).catch(function(){if(done)done(false);});
  }
  window.lxRefreshCartDrawer=refreshDrawer;

  /* ── Add to Cart (AJAX, Drawer bleibt offen) ───────── */
  window.lxAddToCart=function(vid,btn){
    if(btn){btn.textContent='...';btn.disabled=true;}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:1}]})})
    .then(function(r){return r.json();}).then(function(){
      refreshDrawer(function(ok){if(!ok)location.reload();});
    }).catch(function(){location.reload();});
  };

  function refreshBubbles(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      document.querySelectorAll('.cart-bubble__text-count').forEach(function(b){b.textContent=cart.item_count;b.classList.remove('hidden');});
      document.querySelectorAll('.cart-bubble').forEach(function(b){b.classList.remove('visually-hidden');});
      document.querySelectorAll('.theme-drawer__badge').forEach(function(b){b.textContent=cart.item_count;});
    }).catch(function(){});
  }

  /* ── Upsell laden (Figuren ausgeschlossen) ─────────── */
  function loadUpsell(cart,cb){
    /* Warenkorb mit Figur -> KEIN Upsell (Figuren nie mit Guenstigartikeln kombinieren) */
    if(cartFigurState(document.getElementById('cart-drawer')).fig){cb(null);return;}
    var seed=cart.items[0].product_id;
    fetch('/recommendations/products.json?product_id='+seed+'&limit=10&intent=related')
    .then(function(r){return r.json();}).then(function(d){
      var ps=d.products||[];
      var ids=cart.items.map(function(i){return i.product_id;});
      for(var i=0;i<ps.length;i++){
        if(ids.indexOf(ps[i].id)===-1&&ps[i].available!==false&&!isFigurProduct(ps[i])){cb(ps[i]);return;}
      }
      cb(null);
    }).catch(function(){cb(null);});
  }

  /* ── Toast ─────────────────────────────────────────── */
  function showToast(msg){
    var old=document.querySelector('.lx-toast');if(old)old.remove();
    var t=document.createElement('div');
    t.className='lx-toast';
    t.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="#1a7a3a" stroke-width="2" style="width:18px;height:18px"><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="10"/></svg>'+
      '<span>'+esc(msg)+'</span>'+
      '<button type="button" class="lx-toast__link">'+esc(T.to_cart)+' &#x203A;</button>';
    document.body.appendChild(t);
    /* FIX5 (UX-12): echter Button statt <span onclick> */
    t.querySelector('.lx-toast__link').addEventListener('click',function(){var d=document.querySelector('#cart-drawer');if(d&&d.open)d.open();t.classList.remove('lx-toast--visible');});
    requestAnimationFrame(function(){requestAnimationFrame(function(){t.classList.add('lx-toast--visible');});});
    setTimeout(function(){t.classList.remove('lx-toast--visible');setTimeout(function(){t.remove();},400);},4000);
  }

  /* ── Artikelzeilen: Figur = „Lieferzeit ca. 3–4 Wochen“; sonst „Auf Lager“ NUR bei echtem Bestand (data-lx-instock); KEIN Lieferdatum ── */
  var PRICE_RE=/^([€\$][\d,.]+|[\d,.]+\s?€)$/;
  function enhanceRows(root){
    root.querySelectorAll('tr[role="row"]').forEach(function(row){
      if(row.querySelector('th')||row.querySelector('.lx-cart-item-extras'))return;
      var info=row.querySelector('.cart-items__details');if(!info)return;
      var anchor=info.querySelector('.cart-items__product-info')||info.firstElementChild;
      if(!anchor)return;
      var isFig=row.dataset.lxFigur==='true',inStock=row.dataset.lxInstock==='true';
      var html=isFig?'<div class="lx-cis lx-cis--figur">'+esc(T.fig_line)+'</div>':(inStock?'<div class="lx-cis">'+esc(T.instock)+'</div>':'');
      if(html){var ex=document.createElement('div');ex.className='lx-cart-item-extras';ex.innerHTML=html;anchor.parentNode.insertBefore(ex,anchor.nextSibling);}
      info.querySelectorAll('.cart-items__unit-price-wrapper span:not(.visually-hidden)').forEach(function(s){
        var txt=s.textContent.trim();
        if(PRICE_RE.test(txt)&&!s.dataset.lxJe){s.dataset.lxJe='1';s.textContent=T.each+' '+txt;}
      });
    });
  }

  /* ── Info-Bar (idempotent, aktualisiert sich bei Mengenaenderung) ── */
  function ensureInfoBar(container,cart,st){
    var cur=container.querySelector('.lx-ci');
    var key=cart.item_count+'|'+cart.total_discount+'|'+st.fig+'|'+st.std;
    if(cur&&cur.dataset.lxKey===key)return;
    var html=buildInfoBar(st);
    var tmp=document.createElement('div');tmp.innerHTML=html;
    var el=tmp.firstChild;el.dataset.lxKey=key;
    if(cur)cur.replaceWith(el);else container.insertAdjacentElement('afterbegin',el);
  }

  /* ── Checkout-Button-Text + Du-sparst + Trust (nativer Summary-Bereich 4.1.4) ── */
  function enhanceSummary(sum,cart,idPrefix){
    if(!sum)return;
    var ctas=sum.querySelector('.cart__ctas');
    var btn=sum.querySelector('.cart__checkout-button .button-text');
    if(btn){var lbl=T.checkout+' · '+fmtEur(cart.total_price)+' €';if(btn.textContent.trim()!==lbl)btn.textContent=lbl;}
    var save=sum.querySelector('.lx-ft__save');
    var saveHtml=buildSave(cart);
    if(save&&!saveHtml)save.remove();
    else if(save&&saveHtml){var t=document.createElement('div');t.innerHTML=saveHtml;if(save.textContent!==t.firstChild.textContent)save.replaceWith(t.firstChild);}
    else if(!save&&saveHtml&&ctas){ctas.insertAdjacentHTML('beforebegin',saveHtml);}
    var st=cartFigurState(document.getElementById('cart-drawer'));
    var ex=sum.querySelector('.lx-ft-extra');
    if(ex&&ex.dataset.lxSt!==String(st.fig)+st.std){ex.remove();ex=null;}
    if(ctas&&!ex){
      ctas.insertAdjacentHTML('afterend','<div class="lx-ft-extra" data-lx-st="'+st.fig+st.std+'">'+buildTrust(st)+'</div>');
    }
  }

  /* ── Haupt-Enhancement: Drawer ─────────────────────── */
  function enhance(){
    var dlg=document.getElementById('cart-drawer');
    if(!dlg)return;
    var isEmpty=!!dlg.querySelector('[data-cart-drawer-empty]')||!!dlg.querySelector('.cart-drawer--empty');

    if(isEmpty){
      var cnt=dlg.querySelector('.cart-drawer__content');
      if(!cnt||cnt.querySelector('.lx-empty'))return;
      /* Horizon Empty-Elemente verstecken */
      var h=cnt.querySelector('.theme-drawer__title');if(h)h.style.display='none';
      var iw=cnt.querySelector('.cart-drawer__items');
      if(iw){iw.querySelectorAll('p').forEach(function(p){p.style.display='none';});var b=iw.querySelector('.cart-items__empty-button');if(b)b.style.display='none';}
      (iw||cnt).insertAdjacentHTML('afterbegin',buildEmpty());
      return;
    }

    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      if(!cart||cart.item_count===0)return;
      var content=dlg.querySelector('.cart-drawer__content');
      if(!content)return;

      /* 1. Info-Leiste: im Drawer übernimmt das der Liquid-Versandbalken (cart-drawer.liquid) – alte Leiste entfernen */
      var oldCi=content.querySelector('.lx-ci');if(oldCi)oldCi.remove();

      /* 2. Artikel */
      enhanceRows(dlg);

      /* 3. Summary (nativ, sticky): Upsell-Slot, Du-sparst, Checkout-Text, Trust */
      var sum=dlg.querySelector('.cart-drawer__summary');
      if(sum){
        if(!sum.querySelector('#lx-ups-slot')){
          sum.insertAdjacentHTML('afterbegin','<div id="lx-ups-slot"></div>');
          loadUpsell(cart,function(p){
            if(!p)return;
            var slot=document.querySelector('#cart-drawer #lx-ups-slot');
            if(slot&&!slot.innerHTML)slot.innerHTML=buildUpsell(p);
          });
        }
        enhanceSummary(sum,cart);
      }
    });
  }

  /* ── Cart Page Enhancement (4.1.4: .cart-page > .cart-page__items / .cart-page__summary) ── */
  function enhancePage(){
    var pg=document.querySelector('.cart-page');
    if(!pg)return;

    /* Leerer Warenkorb */
    if(pg.classList.contains('cart-page--empty')){
      if(pg.querySelector('.lx-cp-empty'))return;
      var itemsArea=pg.querySelector('.cart-page__items');
      if(!itemsArea)return;
      var loginP=itemsArea.querySelector('p');
      if(loginP)loginP.style.display='none';
      var contBtn=itemsArea.querySelector('.cart-items__empty-button');
      if(contBtn)contBtn.style.display='none';
      pg.querySelectorAll('h1').forEach(function(h){if(!h.offsetParent)h.remove();});
      itemsArea.insertAdjacentHTML('afterbegin',
        '<div class="lx-cp-empty">'+
          '<svg class="lx-cp-empty__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>'+
          '<h1 class="lx-cp-empty__h">'+esc(T.empty_h)+'</h1>'+
          '<div class="lx-cp-empty__p">'+esc(T.empty_p)+'</div>'+
          '<a class="lx-cp-empty__cta" href="'+allUrl()+'">'+esc(T.empty_cta)+'</a>'+
          emptyFeats('lx-cp-empty',16)+
        '</div>'
      );
      return;
    }

    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      if(!cart||cart.item_count===0)return;
      var st=cartFigurState(pg);

      /* 1. Info-Bar + "Weiter einkaufen" innerhalb cart-page__items */
      var itemsBlock=pg.querySelector('.cart-page__items');
      if(itemsBlock){
        if(!itemsBlock.querySelector('.lx-cp-weiter-top')){
          itemsBlock.insertAdjacentHTML('afterbegin','<a href="'+allUrl()+'" class="lx-cp-weiter-top">&larr; '+esc(T.more)+'</a><div class="lx-cp-info"></div>');
        }
        var info=itemsBlock.querySelector('.lx-cp-info');
        if(info)ensureInfoBar(info,cart,st);
      }

      /* 2. Auf Lager + je-Preis pro Artikel */
      enhanceRows(pg);

      /* 3. Sidebar */
      var summary=pg.querySelector('.cart-page__summary');
      if(summary){
        var totalLabel=summary.querySelector('.cart-totals__total-label');
        if(totalLabel&&totalLabel.textContent.trim()!==T.total)totalLabel.textContent=T.total;

        var totalContainer=summary.querySelector('.cart-totals__container');
        /* „Versandkostenfrei“ nur für Deutschland und nur ohne Holzfigur im Warenkorb */
        var shipEl=summary.querySelector('.lx-cp-ship');
        var freeOk=country()==='DE'&&!st.fig;
        if(shipEl&&!freeOk)shipEl.remove();
        if(totalContainer&&freeOk&&!shipEl){
          totalContainer.insertAdjacentHTML('afterend','<div class="lx-cp-ship"><span style="color:var(--lx-sage,#2A6E4C);font-weight:500;font-size:12px">'+esc(T.free_de)+'</span></div>');
        }
        var cp=summary.querySelector('.lx-cp-save');var ctas=summary.querySelector('.cart__ctas');
        var saveHtml='';
        if(cart.total_discount>0){saveHtml='<div class="lx-cp-save">'+esc(T.save)+' '+fmtEur(cart.total_discount)+' € ('+esc(T.discount)+')</div>';}
        if(cp&&!saveHtml)cp.remove();
        else if(cp&&saveHtml){var tmp=document.createElement('div');tmp.innerHTML=saveHtml;if(cp.textContent!==tmp.firstChild.textContent)cp.replaceWith(tmp.firstChild);}
        else if(!cp&&saveHtml&&ctas)ctas.insertAdjacentHTML('beforebegin',saveHtml);

        var btn=summary.querySelector('.cart__checkout-button .button-text');
        if(btn){var lbl=T.checkout+' · '+fmtEur(cart.total_price)+' €';if(btn.textContent.trim()!==lbl)btn.textContent=lbl;}

        var cpt=summary.querySelector('.lx-cp-trust');
        if(cpt&&cpt.dataset.lxSt!==String(st.fig)+st.std){cpt.remove();cpt=null;}
        if(ctas&&!cpt){
          ctas.insertAdjacentHTML('afterend',
            '<div class="lx-cp-trust" data-lx-st="'+st.fig+st.std+'"><div class="lx-cp-ti">'+S_LOCK+' '+esc(T.ssl_long)+'</div><div class="lx-cp-ti">'+S_OK+' '+esc(retText(st))+'</div><div class="lx-cp-ti">'+S_DONE+' '+esc(T.service)+'</div></div>'
          );
        }
        /* FIX5 (UX-10): Gutscheinfeld bleibt eingeklappt (kein Zwangs-Öffnen mehr) */
      }

      /* 4. Headings uebersetzen */
      document.querySelectorAll('h3,h4').forEach(function(h){
        if(h.textContent.trim()==='You may also like')h.textContent=T.also_like;
      });
      document.querySelectorAll('a,button').forEach(function(a){
        if(a.textContent.trim()==='View all')a.textContent=T.view_all;
      });
    });
  }

  /* ── Observer ──────────────────────────────────────── */
  var observer=null,debounce=null;
  function onMut(){
    if(INJECTING)return;
    clearTimeout(debounce);
    debounce=setTimeout(function(){
      INJECTING=true;if(observer)observer.disconnect();
      try{enhance();enhancePage();}catch(e){}
      setTimeout(function(){INJECTING=false;startObs();},500);
    },250);
  }
  function startObs(){
    if(observer)observer.disconnect();
    observer=new MutationObserver(onMut);
    [document.querySelector('#cart-drawer .cart-drawer__inner'),document.querySelector('#cart-drawer cart-items-component'),document.querySelector('.cart-page')].forEach(function(t){if(t)observer.observe(t,{childList:true,subtree:true});});
  }

  /* ── Auto-Open deaktivieren, Toast stattdessen ─────── */
  function disableAutoOpen(){
    var comp=document.querySelector('cart-drawer-component');
    if(comp&&comp.hasAttribute('auto-open')){
      comp.removeAttribute('auto-open');
    }
  }

  /* ── Init ──────────────────────────────────────────── */
  function init(){
    disableAutoOpen();
    enhance();
    enhancePage();
    startObs();
    /* Cart Page: Retries weil Horizon Blocks asynchron laden */
    if(document.querySelector('.cart-page')){
      setTimeout(enhancePage,500);
      setTimeout(enhancePage,1000);
      setTimeout(enhancePage,2000);
    }
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
  else{init();}

  /* Cart-Icon Klick: enhance nach Verzoegerung */
  document.addEventListener('click',function(e){
    if(e.target.closest('cart-drawer-component button')||e.target.closest('.cart-icon')||e.target.closest('cart-icon')){
      setTimeout(function(){INJECTING=false;enhance();},400);
      setTimeout(function(){INJECTING=false;enhance();},800);
    }
  });

  /* Toast bei Add-to-Cart Event */
  var toastEvents=['cart:add','theme:cart:add'];
  toastEvents.forEach(function(evt){
    document.addEventListener(evt,function(){
      showToast(T.added);
      /* Cart-Bubble im Header updaten */
      setTimeout(function(){
        fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
          var bubbles=document.querySelectorAll('.cart-bubble__text-count');
          bubbles.forEach(function(b){b.textContent=cart.item_count;});
        });
      },300);
    });
  });
  /* Fallback: globalen Fetch intercepten fuer Add-to-Cart */
  var origFetch=window.fetch;
  window.fetch=function(){
    var args=arguments;
    var url=typeof args[0]==='string'?args[0]:(args[0]&&args[0].url?args[0].url:'');
    /* PDP (lx-pdp.js) öffnet selbst den Drawer -> dort kein zusätzlicher Toast (FIX5/CT-12) */
    if(url.indexOf('/cart/add')!==-1&&url.indexOf('section')===-1&&!document.querySelector('[data-lxp]')){
      return origFetch.apply(this,args).then(function(resp){
        var clone=resp.clone();
        clone.json().then(function(data){
          if(data&&(data.items||data.id)){
            setTimeout(function(){showToast(T.added);},100);
          }
        }).catch(function(){});
        return resp;
      });
    }
    return origFetch.apply(this,args);
  };
})();
